/* eslint-disable camelcase */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CookieService } from 'src/libs/cookie.service';
import apiClient from 'src/api/api-client';
import constants from 'src/constants';
import { getAuthURI } from '../api';
import { setValue } from './MessageSlice';
// First, create the thunk
const authorize = token => {
  localStorage.setItem('token', token);
  apiClient.setHeader({
    Authorization: `Bearer ${token}`,
  });
};

const clearAuthorize = () => {
  localStorage.removeItem('token');
  apiClient.setHeader({
    Authorization: ``,
  });
};

export const login = createAsyncThunk(
  'auth/login',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const response = await apiClient
        .handleRequest({
          method: 'post',
          url: `${getAuthURI}/login`,
          data: params,
        })
        .then(res => res.data);

      return response;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

const initialState = {
  authed: false,
  loading: 'idle',
  saving: 'idle',
  saving_id: 0,
  currentRequestId: undefined,
  error: null,
};

// Then, handle actions in your reducers:
const authSlice = createSlice({
  name: 'cv',
  initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    logout: (state, action) => {
      CookieService.remove(constants.USER_ACCESS_TOKEN);
      clearAuthorize();
      state.authed = false;
    },
    handleLogin: (state, action) => {
      const { token } = action.payload;
      authorize(token);
      state.authed = true;
    },
  },
  extraReducers: {
    [login.pending]: (state, action) => {
      if (state.loading === 'idle') {
        state.loading = 'pending';
        state.currentRequestId = action.meta.requestId;
      }
    },
    // Add reducers for additional action types here, and handle loading state as needed
    [login.fulfilled]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        const { access_token: token, expires_in } = action.payload;
        CookieService.set(constants.USER_ACCESS_TOKEN, token, {
          maxAge: expires_in,
          path: '/',
        });
        authorize(token);

        state.loading = 'idle';
        state.authed = true;
        state.currentRequestId = undefined;
      }
    },
    [login.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        state.loading = 'idle';
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    },
  },
});

export const { logout, handleLogin } = authSlice.actions;
export default authSlice.reducer;
